module.exports = __webpack_public_path__ + "img/chris_g_11.c18d7479.jpg";